/// <amd-module name="Feed/Legacy/Protocols/Npm/NpmClientTool" />
import * as React from "react";

import { IPackageProtocolClient } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { NpmKey } from "Feed/Legacy/Protocols/Npm/Constants/NpmConstants";
import { INpmConnectToFeedPanelProps, NpmConnectToFeedPanel } from "Feed/Legacy/Protocols/Npm/NpmConnectToFeedPanel";
import { HubAction } from "Feed/Legacy/Types/IHubState";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";
import { FeedView } from "Feed/Common/Contracts/Feed";
import { IVssPageContext } from "VSS/Platform/Context";

export class NpmClientTool implements IPackageProtocolClient {
    public readonly name = NpmKey;

    private pageContext: IVssPageContext;

    constructor(pageContext: IVssPageContext) {
        this.pageContext = pageContext;
    }

    public getConnectPanel(feed: Feed, feedViews: FeedView[], hubAction: HubAction): JSX.Element {
        return React.createElement(NpmConnectToFeedPanel, {
            pageContext: this.pageContext,
            feed,
            feedViews,
            hubAction
        } as INpmConnectToFeedPanelProps);
    }
}
